var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-footer',{staticClass:"footer-box"},[_c('div',{staticClass:"content title"},[_vm._v("上海斯选网络科技有限公司")]),_c('div',{staticClass:"content desc"},[_vm._v("Copyright © 2017 - 2022 Ostay. All Rights Reserved.")])])}
var staticRenderFns = []

export { render, staticRenderFns }